export const AUTH_STORAGE_KEYS = {
  session: 'oyb_auth_session',
  loginPhone: 'oyb_login_phone',
  loginStep: 'oyb_login_step',
  loginChallengeId: 'oyb_login_challenge_id',
  otpResendAt: 'oyb_login_resend_at',
} as const;

export const AUTH_COOKIE_KEYS = {
  sessionPresent: 'oyb_auth_present',
  expiresAt: 'oyb_auth_expires_at',
} as const;

export const AUTH_EVENTS = {
  sessionChanged: 'oyb-auth-session-changed',
} as const;

export const DEFAULT_OTP_RESEND_COOLDOWN_SECONDS = 60;
export const OTP_LENGTH = 6;
